import _ from 'lodash';

/**
 * @name CompletedPhotoController
 * @description Controller for adding a copmleted photo to projects
 * @param {library} $uibModalInstance The modal instance from UI Boostrap
 * @param {object} project The project resolve
 * @param {object} appointment The appointment resolve
 * @param {service} Session The Session service
 * @param {service} Project The project service
 * @param {service} FormatProject The format project service
 * @param {library} _ The Lodash library
 */
function CompletedPhotoController(
  $uibModalInstance,
  project,
  appointment,
  Session,
  Project,
  FormatProject
) {
  let vm = this;

  vm.projectTmp = _.cloneDeep(project);
  vm.appointment = appointment;
  vm.session = Session;
  vm.saveCompletedPhotos = saveCompletedPhotos;
  vm.cancel = cancel;

  /**
   * @name saveCompletedPhotos
   * @description Function to save completed photos to the project
   */
  function saveCompletedPhotos() {
    Project.update(vm.projectTmp).then(function(updatedProject) {
      let formattedProject = FormatProject.format(updatedProject);

      // Close the modal and send the updated appointment and project
      $uibModalInstance.close(formattedProject);
    });
  }

  /**
   * @name cancel
   * @description Function to close the modal without saving
   */
  function cancel() {
    $uibModalInstance.dismiss();
  }
}

angular
  .module('inkfinder')
  .controller('CompletedPhotoController', CompletedPhotoController);



// WEBPACK FOOTER //
// ./components/projects/project/completed-photo/completed-photo.controller.js